import type { SurveysRespondentStrategyInput } from 'generated/resources/datatable.graphql'
import { AvatarNameSelectorDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

interface Props {
  strategy: SurveysRespondentStrategyInput
  onChange: (ids: number[]) => void
}

export function EmployeesStrategy({ strategy, onChange }: Props) {
  const { company } = useCurrentSession()
  const { loading, data } = useQuery(AvatarNameSelectorDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const employeeIds = new Set(strategy.arguments || [])
  const employees = data?.employees.employeeNames || []
  const selectedEmployees = employees
    .filter((employee) => employeeIds.has(employee.id))
    .map((employee) => ({
      ...employee,
      access: {
        avatar: employee.avatar?.url,
      },
    }))

  return (
    <EmployeeSelector
      disabled={loading}
      label={i18n.t('surveys.configuration.participants.employees_label')}
      value={selectedEmployees}
      multiple
      withAvatar
      hideSearchIcon
      usingAccessIds={false}
      onSelect={(employees) => {
        onChange(employees.map((employee) => employee.id))
      }}
    />
  )
}
